<template>
  <header class="app-header">
    <!-- Start::main-header-container -->
    <div class="main-header-container container-fluid">
      <!-- Start::header-content-left -->
      <div class="header-content-left">
        <!-- Start::header-element -->
        <div class="header-element">
          <div class="horizontal-logo">
            <router-link :to="`${url}dashboard`" class="header-logo">
              <img src="/images/brand-logos/desktop-logo.png" alt="logo" class="desktop-logo" />
              <img src="/images/brand-logos/toggle-logo.png" alt="logo" class="toggle-logo" />
              <img src="/images/brand-logos/desktop-dark.png" alt="logo" class="desktop-dark" />
              <img src="/images/brand-logos/toggle-dark.png" alt="logo" class="toggle-dark" />
              <img src="/images/brand-logos/desktop-white.png" alt="logo" class="desktop-white" />
              <img src="/images/brand-logos/toggle-white.png" alt="logo" class="toggle-white" />
            </router-link>
          </div>
        </div>
        <!-- End::header-element -->

        <!-- Start::header-element -->
        <div class="header-element">
          <!-- Start::header-link -->
          <a
            aria-label="Hide Sidebar"
            class="sidemenu-toggle header-link animated-arrow hor-toggle horizontal-navtoggle"
            href="javascript:void(0);"
            @click="ToggleMenu"
            ><span></span
          ></a>

          <!-- End::header-link -->
        </div>
        <!-- End::header-element -->
      </div>
      <!-- End::header-content-left -->

      <!-- Start::header-content-right -->
      <div class="header-content-right">
        <dev-enviroment v-if="isDevEnviroment" />

        <!-- Start::header-element -->
        <div class="header-element header-theme-mode">
          <!-- Start::header-link|layout-setting -->
          <a href="javascript:void(0);" class="header-link layout-setting">
            <span class="light-layout" @click="colorthemeFn('dark')">
              <!-- Start::header-link-icon -->
              <i class="fe fe-moon header-link-icon lh-2"></i>
              <!-- End::header-link-icon -->
            </span>
            <span class="dark-layout" @click="colorthemeFn('light')">
              <!-- Start::header-link-icon -->
              <i class="fe fe-sun header-link-icon lh-2"></i>
              <!-- End::header-link-icon -->
            </span>
          </a>
          <!-- End::header-link|layout-setting -->
        </div>
        <!-- End::header-element -->

        <!-- Start::header-element -->
        <div class="header-element country-selector dropdown">
          <!-- Start::header-link|dropdown-toggle -->
          <a
            id="dropdownMenuLocation"
            v-click-outside="() => (showLocale = false)"
            href="javascript:void(0);"
            class="header-link dropdown-toggle country-Flag"
            data-bs-auto-close="true"
            data-bs-toggle="dropdown"
            @click="() => (showLocale = !showLocale)"
          >
            <span>
              <img :src="`/images/flags/${$i18n.locale}.png`" alt="img" />
            </span>
          </a>
          <!-- End::header-link|dropdown-toggle -->
          <ul
            class="main-header-dropdown dropdown-menu dropdown-menu-end"
            :class="{ 'show-dropdown': showLocale }"
            data-popper-placement="none"
            aria-labelledby="dropdownMenuLocation"
          >
            <li
              v-for="locale in locales"
              :key="locale.locale"
              @click="
                () => {
                  $i18n.locale = locale.locale
                  loadLanguageAsync(locale.locale)
                  showLocale = false
                }
              "
            >
              <a class="dropdown-item d-flex align-items-center" href="javascript:void(0);">
                <span class="avatar avatar-xs lh-1 me-2">
                  <img :src="locale.img" alt="img" />
                </span>
                {{ $t(locale.title) }}
              </a>
            </li>
          </ul>
        </div>
        <!-- End::header-element -->

        <!-- Start::header-element -->
        <div class="header-element header-fullscreen d-xl-flex d-none">
          <!-- Start::header-link -->
          <a href="javascript:void(0);" class="header-link" @click="toggleFullScreen()">
            <i v-if="!isFullScreen" class="fe fe-maximize full-screen-open header-link-icon"></i>
            <i v-if="isFullScreen" class="fe fe-minimize full-screen-close header-link-icon"></i>
          </a>
          <!-- End::header-link -->
        </div>
        <!-- End::header-element -->

        <!-- Start::header-element -->
        <notification-widget />
        <!-- End::header-element -->

        <!-- Start::header-element -->
        <div class="header-element d-flex">
          <!-- Start::header-link|dropdown-toggle -->
          <a
            id="notificationDropdown"
            v-click-outside="() => (showApps = false)"
            href="javascript:void(0);"
            class="header-link dropdown-toggle"
            data-bs-toggle="dropdown"
            data-bs-auto-close="outside"
            aria-expanded="false"
            @click="() => (showApps = !showApps)"
          >
            <i class="fe fe-grid header-link-icon"></i>
          </a>
          <!-- End::header-link|dropdown-toggle -->
          <!-- Start::main-header-dropdown -->
          <div
            class="main-header-dropdown dropdown-menu pb-0 dropdown-menu-end"
            :class="{ 'show-dropdown': showApps }"
            aria-labelledby="notificationDropdown"
          >
            <div class="p-3">
              <div class="d-flex align-items-center justify-content-between">
                <p class="mb-0 fs-17 fw-semibold">{{ $t('header.related_apps') }}</p>
              </div>
            </div>
            <div class="dropdown-divider mb-0"></div>
            <div id="header-shortcut-scroll" class="main-header-shortcuts p-2">
              <div class="row g-2">
                <div v-for="app in relativedAppsOprions" :key="app.name" class="col-4">
                  <a :href="app.link" target="_blank" @click="() => (showApps = false)">
                    <div class="text-center p-3 related-app">
                      <span class="avatar avatar-sm rounded-2 p-1 bg-primary-transparent">
                        <img :src="app.image" :alt="app.name" />
                      </span>
                      <span class="d-block fs-12 text-default">{{ app.name }}</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <!-- End::main-header-dropdown -->
        </div>
        <!-- End::header-element -->

        <!-- Start::header-element -->
        <div class="header-element">
          <!-- Start::header-link|dropdown-toggle -->
          <a
            id="mainHeaderProfile"
            v-click-outside="() => (showProfile = false)"
            href="javascript:void(0);"
            class="header-link dropdown-toggle"
            data-bs-toggle="dropdown"
            data-bs-auto-close="outside"
            aria-expanded="false"
            @click="() => (showProfile = !showProfile)"
          >
            <div class="d-flex align-items-center">
              <div class="header-link-icon">
                <img
                  v-if="user.avatar"
                  :src="user.avatar"
                  alt="profile-avatar"
                  width="32"
                  height="32"
                  class="rounded-circle"
                />
                <img
                  v-else
                  src="/images/faces/1.jpg"
                  alt="profile-avatar"
                  width="32"
                  height="32"
                  class="rounded-circle"
                />
              </div>
            </div>
          </a>
          <!-- End::header-link|dropdown-toggle -->
          <ul
            class="main-header-dropdown dropdown-menu pt-0 overflow-hidden header-profile-dropdown dropdown-menu-end"
            :class="{ 'show-dropdown': showProfile }"
            aria-labelledby="mainHeaderProfile"
          >
            <li>
              <div
                v-if="
                  auth.loggedUser.first_name ||
                  auth.loggedUser.last_name ||
                  auth.loggedUser.email ||
                  auth.loggedUser.gerencia
                "
                class="header-navheading border-bottom"
              >
                <h6
                  v-if="auth.loggedUser.first_name || auth.loggedUser.last_name"
                  class="main-notification-title"
                >
                  {{ auth.loggedUser.first_name }}
                  {{ auth.loggedUser.last_name }}
                </h6>
                <p v-if="auth.loggedUser.email" class="main-notification-text mb-0">
                  {{ auth.loggedUser.email }}
                </p>
                <p v-if="auth.loggedUser.gerencia && false" class="main-notification-text mb-0">
                  {{ auth.loggedUser.gerencia }}
                </p>
              </div>
            </li>
            <li>
              <router-link class="dropdown-item d-flex border-bottom" :to="`${url}profile`"
                ><i class="fe fe-user fs-16 align-middle me-2"></i
                >{{ $t('labels.profile.text') }}</router-link
              >
            </li>
            <!-- <li><router-link class="dropdown-item d-flex border-bottom" :to="`${url}apps/mail/mailinbox`"><i
                  class="fe fe-inbox fs-16 align-middle me-2"></i>Inbox <span
                  class="badge bg-success ms-auto">25</span></router-link>
            </li>
            <li><router-link class="dropdown-item d-flex border-bottom border-block-end"
                :to="`${url}pages/notificationlist`"><i
                  class="fe fe-compass fs-16 align-middle me-2"></i>Activity</router-link></li>
            <li><router-link class="dropdown-item d-flex border-bottom" :to="`${url}pages/settings`"><i
                  class="fe fe-settings fs-16 align-middle me-2"></i>Settings</router-link></li>
            <li><router-link class="dropdown-item d-flex border-bottom" :to="`${url}advancedui/chat`"><i
                  class="fe fe-headphones fs-16 align-middle me-2"></i>Support</router-link> </li> -->
            <li>
              <router-link class="dropdown-item d-flex" :to="`${url}login`" @click="onLogout"
                ><i class="fe fe-power fs-16 align-middle me-2"></i
                >{{ $t('login.log_out') }}</router-link
              >
            </li>
          </ul>
        </div>
        <!-- End::header-element -->

        <!-- Start::header-element -->
        <!-- <div class="header-element"> -->
        <!-- Start::header-link|switcher-icon -->
        <!-- <a href="javascript:void(0);" class="header-link switcher-icon" data-bs-toggle="offcanvas"
            data-bs-target="#switcher-canvas">
            <i class="fe fe-settings header-link-icon"></i>
          </a> -->
        <!-- End::header-link|switcher-icon -->
        <!-- </div> -->
        <!-- End::header-element -->
      </div>
      <!-- End::header-content-right -->
    </div>
    <!-- End::main-header-container -->
  </header>
</template>

<script>
import { computed, reactive } from 'vue'
import { authStore } from '@/stores/auth'
import { switcherStore } from '@/stores/switcher'
import { notificationList } from '@/data/headerdata.js'
import { locales, loadLanguageAsync } from '@/plugins/i18n'
import { useI18n } from 'vue-i18n'
import DevEnviroment from '@/components/common/DevEnviroment.vue'
import NotificationWidget from '@/shared/components/header/NotificationWidget.vue'

export default {
  components: { DevEnviroment, NotificationWidget },
  setup() {
    const switcher = switcherStore()
    const { t } = useI18n()

    const relativedAppsOprions = computed(() => [
      {
        name: t('header.inspector'),
        image: '/images/apps/copec.png',
        link: 'https://inspector2.fluxsolar.cl/'
      },
      {
        name: t('header.monitor'),
        image: '/images/apps/copec.png',
        link: 'https://monitor.fluxsolar.cl/'
      },
      {
        name: t('header.help_desk'),
        image: '/images/apps/copec.png',
        link: 'https://mesaayuda.fluxsolar.cl/'
      }
    ])

    const colorthemeFn = (value) => {
      localStorage.setItem('spruhacolortheme', value)
      switcher.colorthemeFn(value)
      localStorage.removeItem('spruhabodylightRGB')
      localStorage.removeItem('spruhabodyBgRGB')
    }

    return {
      switcher,

      locales,
      relativedAppsOprions,

      colorthemeFn,
      loadLanguageAsync
    }
  },
  data() {
    return {
      showLocale: false,
      showApps: false,
      showProfile: false,
      auth: reactive(authStore()),
      notificationList,
      isFullScreen: false,
      value: null,
      url: import.meta.env.BASE_URL
    }
  },
  computed: {
    user() {
      return this.auth.loggedUser
    },
    isDevEnviroment() {
      return (
        import.meta.env.VITE_ENVIROMENT == 'preproduction' ||
        import.meta.env.VITE_MODE === 'development'
      )
    }
  },
  //sticky-pin
  created() {
    this.auth.getUserRoles()
    window.addEventListener('scroll', this.handleScroll)
    this.handleScroll()
  },
  unmounted() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  mounted() {
    document.addEventListener('fullscreenchange', this.fullscreenchanged)
  },
  methods: {
    async onLogout() {
      this.showProfile = false
      await this.auth.logoutAction()
    },
    ToggleMenu() {
      const html = document.querySelector('html')
      if (window.innerWidth <= 992) {
        const dataToggled = html.getAttribute('data-toggled')
        if (dataToggled == 'open') {
          html.setAttribute('data-toggled', 'close')
        } else {
          html.setAttribute('data-toggled', 'open')
        }
      } else {
        const menuNavLayoutType = html.getAttribute('data-nav-style')
        const verticalStyleType = html.getAttribute('data-vertical-style')
        if (menuNavLayoutType) {
          const dataToggled = html.getAttribute('data-toggled')
          if (dataToggled) {
            html.removeAttribute('data-toggled')
          } else {
            html.setAttribute('data-toggled', menuNavLayoutType + '-closed')
          }
        } else if (verticalStyleType) {
          const dataToggled = html.getAttribute('data-toggled')
          if (verticalStyleType == 'doublemenu') {
            if (
              html.getAttribute('data-toggled') === 'double-menu-open' &&
              document.querySelector('.double-menu-active')
            ) {
              html.setAttribute('data-toggled', 'double-menu-close')
            } else {
              if (document.querySelector('.double-menu-active')) {
                html.setAttribute('data-toggled', 'double-menu-open')
              }
            }
          } else if (dataToggled) {
            html.removeAttribute('data-toggled')
          } else {
            switch (verticalStyleType) {
              case 'closed':
                html.setAttribute('data-toggled', 'close-menu-close')
                break
              case 'icontext':
                html.setAttribute('data-toggled', 'icon-text-close')
                break
              case 'overlay':
                html.setAttribute('data-toggled', 'icon-overlay-close')
                break
              case 'detached':
                html.setAttribute('data-toggled', 'detached-close')
                break
            }
          }
        }
      }
    },
    toggleFullScreen() {
      const element = document.documentElement // Full-screen target element

      if (
        document.fullscreenElement ||
        document.mozFullScreenElement ||
        document.webkitFullscreenElement
      ) {
        // If in full-screen mode, exit it
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen()
        }
      } else {
        // If not in full-screen mode, enter it
        if (element.requestFullscreen) {
          element.requestFullscreen()
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen()
        } else if (element.webkitRequestFullscreen) {
          element.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT)
        }
      }
    },
    removeNotification(item) {
      this.notificationList = this.notificationList.filter((itm) => itm.id != item.id)
    },
    fullscreenchanged() {
      if (document.fullscreenElement) {
        this.isFullScreen = true
      } else {
        this.isFullScreen = false
      }
    },
    //sticky-pin
    handleScroll() {
      if (window.scrollY > 30) {
        const Scolls = document.querySelectorAll('.sticky')
        Scolls.forEach((e) => {
          e.classList.add('sticky-pin')
        })
      } else {
        const Scolls = document.querySelectorAll('.sticky')
        Scolls.forEach((e) => {
          e.classList.remove('sticky-pin')
        })
      }
    }
  }
}
</script>

<style scoped>
.show-dropdown {
  position: absolute;
  inset: 0px auto auto 0px;
  margin: 0px;
  transform: translate(0px, 40px);
  display: block;
}
</style>
